import { Component } from '@angular/core';
import { IonicPage, ViewController, NavParams } from 'ionic-angular';

import{Condominium}from '../../models/models';

@IonicPage()
@Component({
	selector: 'page-timetable-modal',
	templateUrl: 'timetable-modal.html',
})
export class TimetableModalPage {
	//public url:string;
	condominium:Condominium;

	constructor(
		public viewCtrl: ViewController,
		public navParams: NavParams
	){
		//this.url=navParams.get('url');
		this.condominium=<Condominium>navParams.get('condominium');
		console.log('Condominio per la timetable: '+this.condominium);
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/pages/timetable-modal/timetable-modal.ts